export default __webpack_public_path__ + "static/media/auditDefault.d45f823a.svg";